import { useLocation, useNavigate } from "react-router-dom";

export const ManagementHeaderNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navItems = [
    {
      label: "Exchange",
      icon: "swap_horiz",
      path: "/invoice-approvals/exchange-management",
      color: "from-blue-500 to-blue-600",
    },
    {
      label: "Bank",
      icon: "account_balance",
      path: "/invoice-approvals/bank-management",
      color: "from-green-500 to-green-600",
    },
    {
      label: "Charges",
      icon: "receipt",
      path: "/invoice-approvals/off-ramp-charge-management",
      color: "from-purple-500 to-purple-600",
    },
  ];

  return (
    <div className="flex items-center gap-1 ml-8 bg-bg-base rounded-xl p-1 shadow-sm border border-border-subtle">
      {navItems.map((item) => {
        const isActive = location.pathname.startsWith(item.path);
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`
              group relative flex items-center gap-2 px-4 py-2 rounded-lg text-[11px] font-semibold
              transition-all duration-300 ease-out transform
              ${
                isActive
                  ? `bg-gradient-to-r ${item.color} text-white shadow-md scale-105 z-10`
                  : "text-text-subtle hover:text-text-base hover:bg-bg-button-secondary hover:scale-105"
              }
            `}
            style={{ minWidth: 100 }}
          >
            <span
              className={`material-symbols-outlined text-[16px] transition-transform duration-300 ${
                isActive ? "scale-110" : "group-hover:scale-110"
              }`}
            >
              {item.icon}
            </span>
            <span className="whitespace-nowrap">{item.label}</span>

            {/* Active indicator dot */}
            {isActive && (
              <div className="absolute -top-1 -right-1 w-2 h-2 bg-white rounded-full shadow-sm animate-pulse" />
            )}

            {/* Hover glow effect */}
            {!isActive && (
              <div
                className={`
                absolute inset-0 opacity-0 group-hover:opacity-20 
                bg-gradient-to-r ${item.color} rounded-lg 
                transition-opacity duration-300
              `}
              />
            )}
          </button>
        );
      })}
    </div>
  );
};
